/**
 * Generates display initials from a user's name or email.
 *
 * Examples:
 * - "Saravanan CG" → "SC"
 * - "Saravanan C G" → "SG"
 * - "Saravanan" → "S"
 * - "saravanan.cg@hasnatech.com" → "SC"
 * - "saravanan@hasnatech.com" → "S"
 * - empty / null → "–"
 */
export const initialsOf = (name?: string | null, email?: string | null): string => {
  // console.log("initialsOf", name, email);
  const raw = (name && name.trim()) || (email && email.trim()) || "";
  if (!raw) return "–";

  // If raw is an email address, extract the local part before @
  const clean = raw.includes("@") ? raw.split("@")[0]! : raw;

  // Split on whitespace, dots, underscores, dashes
  const parts = clean
    .split(/[\s._-]+/)
    .filter(Boolean);

  if (parts.length === 0) return "–";
  if (parts.length === 1) {
    return parts[0]![0]!.toUpperCase();
  }
  // Two or more words/tokens: use first letter of first part and first letter of second (or last) part
  const first = parts[0]![0]!;
  const second = parts.length > 2 && parts[1]!.length === 1
    ? parts[parts.length - 1]![0]!
    : parts[1]![0]!;

  return (first + second).toUpperCase();
};
